<app-view-photo
  imageType="avatar"
  [imageURL]="photoControl.value?.base64Data"
  [readonly]="readonly"
  (imageURLChange)="setImageURL($event)"
>
</app-view-photo>
